"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fns_1 = require("../helpers/fns");
const uuid_1 = require("uuid");
class SyneriseBrowserDriver {
    constructor() {
        this.name = 'SyneriseBrowserDriver';
        this.salt = 'synerise';
    }
    load() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.reportDebug('[Synerise] Load');
                yield this.checkIfLoaded();
                return true;
            }
            catch (e) {
                return false;
            }
        });
    }
    reportDebug(_error) {
        if (window && typeof console !== 'undefined' && console.debug) {
            console.debug(_error);
        }
    }
    supportsEvent(event) {
        return SyneriseBrowserDriver.SUPPORTED_EVENTS.includes(event.name) || event.name.indexOf('custom.') >= 0;
    }
    track(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.reportDebug('[Synerise] track');
            if ((0, fns_1.isCustomEvent)(event)) {
                return yield this.trackCustom(event);
            }
            const data = event.getData();
            this.reportDebug('[Synerise] track ' + event.name);
            switch (event.name) {
                case 'page_view':
                    return yield this.trackPageView(data);
                case 'add_payment_info':
                    return yield this.trackAddPaymentInfo(data);
                case 'add_to_cart':
                    return yield this.trackAddToCart(data);
                case 'purchase':
                    return yield this.trackPurchase(data);
                case 'subscribe':
                    return yield this.subscribe(data);
                case 'unsubscribe':
                    return yield this.unsubscribe(data);
                case 'view_cart':
                    return yield this.trackViewCart(data);
                case 'view_item':
                    return yield this.trackViewItem(data);
                case 'view_item_list':
                    return yield this.trackViewItemList(data);
                case 'user_data_update':
                    return yield this.updateUserData(data);
                case 'login':
                    return yield this.trackLogin(data);
                case 'sign_up':
                    return yield this.trackSignUp(data);
                default:
                    throw new TypeError(`Event ${event.name} not supported!`);
            }
        });
    }
    trackPageView(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (window && window.SR && 'SR' in window && 'event' in window.SR) {
                this.reportDebug('trackPageView');
                window.SR.event.pageVisit({
                    uri: '/' + data.pagePath,
                    title: data.pageTitle,
                    currency: data.currency
                }).then(function () {
                    if (window && window.SR && 'SR' in window && 'dynamicContent' in window.SR) {
                        window.SR.dynamicContent.get();
                    }
                });
            }
        });
    }
    trackCustom(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.reportDebug(['[Synerise custom track]', event]);
            const data = event.forDriver(this.name);
            if (data === null) {
                return;
            }
            if (typeof data.event_name !== 'string') {
                throw new TypeError(`Custom event ${event.name} has to provide event name for ${this.name} [forDriver.event_name]`);
            }
            if (data.event_payload && typeof data.event_payload !== 'object') {
                throw new TypeError(`Custom event ${event.name} has to provide event payload for ${this.name} [forDriver.event_payload]`);
            }
            if (data.event_type === 'form') {
                this.reportDebug([
                    '[Synerise custom track.form]',
                    data.event_name,
                    data.event_payload,
                    data.event_mapping
                ]);
                return this.sendForm(data.event_name, data.event_payload, data.event_mapping);
            }
            this.reportDebug([
                '[Synerise custom track.push]',
                data.event_name,
                data.event_payload,
                data.label
            ]);
            return this.push(data.event_name, data.event_payload, data.label);
        });
    }
    push(eventName, payload, label) {
        if (window && window.SR && 'SR' in window && 'event' in window.SR && 'trackCustomEvent' in window.SR.event) {
            window.SR.event.trackCustomEvent(eventName, payload, label);
        }
    }
    sendForm(eventName, payload, mapping) {
        if (window && window.SR && 'SR' in window && 'event' in window.SR && 'sendFormData' in window.SR.event) {
            window.SR.event.sendFormData(eventName, payload, mapping);
        }
    }
    checkIfLoaded(timeout = 0) {
        return new Promise((resolve, reject) => {
            if (window.SR) {
                resolve();
            }
            else if (timeout >= SyneriseBrowserDriver.AVAILABILITY_CHECK_MAX_TIMEOUT) {
                reject();
            }
            else {
                setTimeout(() => {
                    this.checkIfLoaded(timeout + SyneriseBrowserDriver.AVAILABILITY_CHECK_TIMEOUT).then(() => resolve())
                        .catch(() => reject());
                }, SyneriseBrowserDriver.AVAILABILITY_CHECK_TIMEOUT);
            }
        });
    }
    monetaryValue(value) {
        return Math.round((value + Number.EPSILON) * 100) / 100;
    }
    trackLogin(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.reportDebug(['[Debug login]', data]);
            this.sendForm('login', data);
            // const identify = this.setUuidAndIdentityHash(data)
            // if (identify) {
            //   this.push('client.identify', data as Record<string, string>, 'Client log in')
            //   console.debug(['[Synerise].client.identify:', data as Record<string, string>])
            // }
        });
    }
    updateUserData(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('client.createOrUpdate', data, 'Client update data in account');
            console.debug(['[Synerise].client.createOrUpdate:', data]);
        });
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    setUuidAndIdentityHash(data) {
        if (window && window.SR && 'SR' in window && 'event' in window.SR && 'trackCustomEvent' in window.SR.event && data.email) {
            let hash = window.SR.client.getIdentityHash();
            const uuid = (0, uuid_1.v5)(data.email + this.salt, uuid_1.v5.URL);
            if (!hash) {
                hash = window.SR.client.hashIdentity(data.email);
            }
            const newHash = window.SR.client.hashIdentity(data.email);
            // console.debug(['hash:', hash])
            // console.debug(['newHash:', newHash])
            if (hash !== newHash) {
                console.debug(['New UUID and Hash:', uuid, newHash]);
                window.SR.client.setUuidAndIdentityHash(newHash, uuid);
                return true;
            }
        }
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    createJWT(data) {
        if (window && window.SR && 'SR' in window && 'event' in window.SR && 'trackCustomEvent' in window.SR.event) {
            let hash = window.SR.client.getIdentityHash();
            const uuid = (0, uuid_1.v5)(data.email + this.salt, uuid_1.v5.URL);
            // console.debug(['UUID:', uuid])
            if (!hash) {
                hash = window.SR.client.hashIdentity(data.email);
            }
            window.SR.client.setUuidAndIdentityHash(hash, uuid);
            // const privateKey = ''
            // const jwt = await new jose.SignJWT({
            //   uuid: uuid,
            //   email: data.email
            // })
            //   .setProtectedHeader({ alg: 'RS256', typ: 'JWT' })
            //   .setExpirationTime('24h')
            //   .sign(privateKey)
            // // const jwt = window.SR.client.setAccessToken()
            // console.debug(['[JTW].client.createOrUpdate:', jwt])
            // window.SR.client.update(data as Record<string, string>, 'TEST')
        }
        return '';
    }
    trackSignUp(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // this.setUuidAndIdentityHash(data)
            // const jwt = this.createJWT(data)
            this.sendForm('signup', data);
            // this.push('client.createOrUpdate', data as Record<string, string>, 'Client create account')
            // console.debug(['[Synerise].client.createOrUpdate:', data as Record<string, string>])
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackAddPaymentInfo(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            // this.push('event.checkout-data-step')
            // this.push('client.update', {
            //   'First name': data.customer?.firstname,
            //   'Last name': data.customer?.lastname,
            //   email: data.customer?.email,
            //   phone_number: data.customer?.telephone
            // })
        });
    }
    unsubscribe(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.sendForm('newsletter-unsubscribe', {
                email: _data.email
            });
        });
    }
    subscribe(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.sendForm('newsletter-agreement', {
                email: _data.email,
                list: _data.list,
                smsOffers: _data.allow_sms_marketing,
                emailOffers: _data.allow_marketing,
                allowPolicy: _data.allow_policy,
                newsletterLanguage: _data.language
            });
        });
    }
    trackViewCart(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.push('cart.status', {
                currency: data.currency,
                totalQuantity: data.totalQuantity,
                value: this.monetaryValue(data.value),
                products: this.getItems(data)
            });
        });
    }
    getItems(data) {
        const items = [];
        Array.isArray(data.items) ? data.items.map((item) => (items.push({
            sku: item.id,
            quantity: item.quantity,
            brand: item.brand,
            category: item.category
        }))) : [];
        return items;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackPurchase(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackAddToCart(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackViewItem(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    trackViewItemList(_data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            //
        });
    }
}
exports.default = SyneriseBrowserDriver;
SyneriseBrowserDriver.SUPPORTED_EVENTS = [
    'page_view',
    'user_data_update',
    'subscribe',
    'unsubscribe',
    'add_payment_info',
    'add_to_cart',
    'purchase',
    'view_cart',
    'view_item',
    'view_item_list',
    'login',
    'sign_up'
];
SyneriseBrowserDriver.AVAILABILITY_CHECK_TIMEOUT = 250;
SyneriseBrowserDriver.AVAILABILITY_CHECK_MAX_TIMEOUT = 1500;
//# sourceMappingURL=synerise.browser-driver.js.map